export default __webpack_public_path__ + "static/media/go-to-chat.a91849f6.svg";